import { render, staticRenderFns } from "./RateOurService.vue?vue&type=template&id=40e2b479"
import script from "./RateOurService.vue?vue&type=script&lang=js"
export * from "./RateOurService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40e2b479')) {
      api.createRecord('40e2b479', component.options)
    } else {
      api.reload('40e2b479', component.options)
    }
    module.hot.accept("./RateOurService.vue?vue&type=template&id=40e2b479", function () {
      api.rerender('40e2b479', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RateOurService.vue"
export default component.exports